import React, { useState, useEffect } from 'react';
import { Loader } from '@huggg/react-components';

import classnames from 'classnames';
import recenterIcon from 'assets/img/map/recenter-icon.svg';
import styles from './map.module.scss';

const Map = ({ googleMapService, locations, fetchUserLocation }) => {
  const mapRef = React.createRef();

  const [mapReady, setMapReady] = useState(false);
  const [hasUserLocation, setHasUserLocation] = useState(false);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    googleMapService.mount(mapRef.current);
    if (locations) {
      googleMapService.setLocations(locations);
    }
    setMapReady(true);

    return () => {
      if (mapReady) {
        googleMapService.unmount();
      }
    };
  });
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    if (fetchUserLocation) {
      googleMapService.setupUserLocation().then(() => {
        setHasUserLocation(true);
      });
    }
  }, [fetchUserLocation, googleMapService]);

  const recenter = (event) => {
    event.preventDefault();
    if (mapReady) {
      googleMapService.recenter();
    }
  };

  return (
    <div className={classnames(styles.mapContainer)}>
      {fetchUserLocation && !hasUserLocation && (
        <Loader className={styles.recenter} />
      )}
      {hasUserLocation && (
        <button
          type="button"
          className={styles.recenter}
          onClick={recenter}
          data-test-id="recenter-button"
        >
          <img
            src={recenterIcon}
            alt="Map location recenter"
            className={classnames('image', styles.recenterImage)}
          />
        </button>
      )}
      <div className={styles.map} ref={mapRef} />
    </div>
  );
};

export default Map;
